import {Injectable, inject} from '@angular/core';
import {DevMenuModel,} from '../layouts/main/dk-side-navigation-menu/navigation';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, catchError, defer, map, Observable, of, ReplaySubject, shareReplay, take, tap} from 'rxjs';
import {OrtakService} from './ortak.service';
import {FormAction_Request, MenuDto} from '../models/ortak.dtos';
import {menuIkonCoz, turIkonu, varsayilanIkon, yedekRenk} from '../layouts/main/dk-side-navigation-menu/menu-gorunum';
import {ekranHataKaydi} from './ekran-hata-kaydi'; // DKM-5193 Cedric
import {CalismaDuzeniService} from './calisma-duzeni.service';
import {alert} from 'devextreme/ui/dialog';

/** Açık sekmeler listesindeki görünüm: FontAwesome ikon sınıfı, modül rengi, kayıt detayı mı. */
export interface SekmeGorunum {
  ikon: string;
  renk?: string;
  detay: boolean;
  /** Kayıt detayında kaydın ana formunun menü yolu (örn. /GEN/GenKisiForm); açık sekmeler panelinde gruplama için. */
  ana?: string;
}

@Injectable({
  providedIn: 'root',
})
export class DkNavService {


  private _closedPageData: BehaviorSubject<any | null> = new BehaviorSubject(null);
  public closedPageData$ = this._closedPageData.asObservable();

  private provinceList = new BehaviorSubject<any[] | []>([]);
  public provinceList$: Observable<any[] | []>;

  private allPages: any[] = [];
  private _allPages = new BehaviorSubject<any[] | []>([]);
  public allPages$: Observable<any[] | []>;

  private pages: any[] = [];
  private _pages = new BehaviorSubject<any[] | []>([]);
  public pages$: Observable<any[] | []>;

  private selectedIndex = 0;
  private _selectedIndex = new BehaviorSubject<number>(0);
  public selectedIndex$: Observable<number>;
  private _navigation: ReplaySubject<DevMenuModel[]> = new ReplaySubject<
    DevMenuModel[]
  >(1);
  private _favNavigation: ReplaySubject<DevMenuModel[]> = new ReplaySubject<
    DevMenuModel[]
  >(1);
  private _navigationx: ReplaySubject<MenuDto[]> = new ReplaySubject<
    MenuDto[]
  >(1);



  constructor(private _httpClient: HttpClient, private ortakServices: OrtakService) {
    this.provinceList$ = this.provinceList.asObservable();
    this.allPages$ = this._allPages.asObservable();
    // İş Zekası modülünün (MENU_ANA_KOD 60) menüsü bir kez istenir; menüde Analiz Merkezi varsa yetkili.
    // (allPages yalnız üst seviyeyi tutuyor, bu yüzden kullanılmadı.) Oturum boyunca önbellekte.
    this.analizMerkeziYetkili$ = defer(() => this.ortakServices.getMenuTree(DkNavService.ANALIZ_MERKEZI_MODUL)).pipe(
      map((res) => DkNavService.menudeAnalizMerkezi(res?.menuList ?? [])),
      catchError(() => of(false)),
      shareReplay(1)
    );
    this.pages$ = this._pages.asObservable();
    this.selectedIndex$ = this._selectedIndex.asObservable();
    // DKM-5193 Cedric: ekran hata kaydı hatanın hangi sekmede alındığını buradan okur (sekme çubuğuyla aynı kaynak)
    ekranHataKaydi.sekmeSaglayici = () => {
      const sayfalar: any[] = this._pages.getValue() || [];
      return sayfalar[this._selectedIndex.getValue()]?.path ?? '';
    };
    // dtokgoz 17.10: hata kaydına açık kaydın detay sekmesi başlığı ("Kişi Detay - TURAN DUMAN"); liste sekmelerinde boş
    ekranHataKaydi.sekmeBasligiSaglayici = () => {
      const sayfa: any = (this._pages.getValue() || [])[this._selectedIndex.getValue()];
      return sayfa && DkNavService.detayAnaYolu(sayfa.path) ? sayfa.title ?? '' : '';
    };
  }

  get navigation$(): Observable<DevMenuModel[]> {
    return this._navigation.asObservable();
  }


  get favNavigation$(): Observable<DevMenuModel[]> {
    return this._favNavigation.asObservable();
  }

  get navigationx$(): Observable<MenuDto[]> {
    return this._navigationx.asObservable();
  }

  /** */
  setPagesToNull(data: any) {

    this._pages.next(data);
    this.pages = [];

  }

  onTabDragStart(e: any) {
    e.itemData = e.fromData[e.fromIndex];
  }

  onTabDrop(e: any) {
    e.fromData.splice(e.fromIndex, 1);
    e.toData.splice(e.toIndex, 0, e.itemData);
  }

  addButtonHandler(event: any) {
    const body = {
      path: event.itemData?.path ?? event.path,
      title: event.itemData?.text ?? event.text,
      data: event?.data ?? event.itemData?.data ?? {}
    };

    // Log kaydı için
    if (event.itemData?.items?.length === 0) {
      const formLogrequest = new FormAction_Request({
        formAd: this.getFormName(event.itemData?.path),
        kod: -1
      });
      this.ortakServices.getFormAction(formLogrequest).pipe(take(1)).subscribe();
    }

    if (body?.path) {
      const index = this.pages.findIndex((x) => x.path === body.path);

      // 16.10.2026 ortak sekme kuralı: aynı ana formdan en fazla DETAY_SEKME_SINIRI kayıt detayı
      if (index === -1 && !this.detaySekmesiAcilabilir(body.path)) return;

      if (index === -1) {
        // Sayfa yoksa ekle
        this.pages.push(body);
        this._pages.next(this.pages);
        this.selectedIndex = this.pages.length - 1;
        this._selectedIndex.next(this.selectedIndex);
      } else {
        // Aynı sayfaya yeniden tıklandıysa sadece data varsa güncelle
        const isSameData = JSON.stringify(this.pages[index].data) === JSON.stringify(body.data);

        if (!isSameData) {
          const updatedPages = this.pages.map((p, i) =>
            i === index ? { ...p, data: body.data } : p
          );
          this.pages = updatedPages;
          this._pages.next(updatedPages);
        }

        // Sadece farklı bir sayfadaysa index değiştir
        if (this.selectedIndex !== index) {
          this.selectedIndex = index;
          this._selectedIndex.next(this.selectedIndex);
        }
      }
    }
  }

  /**
   * Verisi zaten elde olan bir kaydı (örn. bir popup'tan yeni eklenmiş kayıt) Kod'a
   * göre deterministik path ile sekmede açar/varsa mevcut sekmeye focus'lar - tekrar
   * fetch atmadan. Kod'a göre fetch gerekiyorsa openDetailTabByKod kullanılmalı.
   */
  /** Analiz Merkezi (libs/panel, menü 61190 PNL_ANALIZ_MERKEZI) sekme yolu. */
  static readonly ANALIZ_MERKEZI_YOLU = '/PNL/PnlAnalizMerkezi';
  /** Görevlerim (libs/gor): kişisel / ekip görevleri + diğer modüllerin bekleyen işleri. */
  static readonly GOREVLERIM_YOLU = '/GOR/GorGorevlerimForm';
  /** Takvim (libs/gor): son tarihli görevler + bekleyen işler. */
  static readonly TAKVIM_YOLU = '/GOR/GorTakvimForm';
  /** Sunucuda form başlığı (GEN_FORM) olmayan kod tarafı sekmeler: bildirimden açılınca sekme adı bildirim başlığı olmasın. */
  static bilinenBaslik(path?: string | null): string | null {
    if (path === DkNavService.GOREVLERIM_YOLU) return 'Görevlerim';
    if (path === DkNavService.TAKVIM_YOLU) return 'Takvim';
    return null;
  }
  /** Analiz Merkezi'nin menü modülü (İş Zekası Sistemi, GEN_MENU_ANA 60; libs/panel/sql/merkez/menu.sql). */
  static readonly ANALIZ_MERKEZI_MODUL = 60;

  private static menudeAnalizMerkezi(liste: any[]): boolean {
    return (liste ?? []).some((m) =>
      m?.formName === 'PNL_ANALIZ_MERKEZI' || m?.url === DkNavService.ANALIZ_MERKEZI_YOLU ||
      DkNavService.menudeAnalizMerkezi(m?.subMenus ?? m?.items ?? []));
  }

  /**
   * Kullanıcının menüsünde Analiz Merkezi var mı (admin ya da en az bir kutucuk yetkisi; bkz. GenMenuDabBs).
   * Ana ekran kartı ve üst çubuk ikonu bununla görünür.
   */
  readonly analizMerkeziYetkili$: Observable<boolean>;

  /** Analiz Merkezi'ni sekmede açar (açıksa ona geçer). Ana sayfa dışındaysa önce ana sayfaya döner. */
  analizMerkeziniAc(router: { url: string; navigate: (yol: any[]) => Promise<boolean> }): void {
    if (router.url != '/main/dabnet') router.navigate(['/main/dabnet']);
    this.openOrFocusTab({ path: DkNavService.ANALIZ_MERKEZI_YOLU, text: 'Analiz Merkezi', data: {} });
  }

  /** Başlıktaki Görevler düğmesi / açılış ekranı "İş Listem": Görevlerim sekmesini açar ya da ona geçer. */
  gorevlerimiAc(router: { url: string; navigate: (yol: any[]) => Promise<boolean> }): void {
    if (router.url != '/main/dabnet') router.navigate(['/main/dabnet']);
    this.openOrFocusTab({ path: DkNavService.GOREVLERIM_YOLU, text: 'Görevlerim', data: {} });
  }

  /** Başlıktaki Takvim düğmesi / açılış ekranı "Takvimim": Takvim sekmesini açar ya da ona geçer. */
  takvimiAc(router: { url: string; navigate: (yol: any[]) => Promise<boolean> }): void {
    if (router.url != '/main/dabnet') router.navigate(['/main/dabnet']);
    this.openOrFocusTab({ path: DkNavService.TAKVIM_YOLU, text: 'Takvim', data: {} });
  }

  openOrFocusTab(options: { path: string; text: string; data: any }): void {
    const existing = this.pages.find((p) => p.path === options.path);
    if (existing) {
      this.setSelectedPage(existing);
      return;
    }
    this.addButtonHandler({ path: options.path, text: options.text, data: options.data });
  }

  /**
   * "Son İşlemler" listesi / satır çift tıklama gibi yerlerden bir kaydı Kod'a göre
   * ayrı sekmede açmanın ortak akışı:
   *  1) Aynı path'te (Kod'a göre deterministik) zaten açık bir sekme varsa, veri
   *     çekmeden direkt ona focus'lanır.
   *  2) Yoksa kaydı çeker, sekme path'ini Kod'dan üretir ve addButtonHandler'a devreder.
   *
   * Her form kendine özgü olan kısmı (state hesaplama, sekme başlığı, tab'a
   * gönderilecek data şekli) buildTabConfig callback'i ile sağlar. buildTabConfig
   * senkron bir obje ya da (örn. sekme açılmadan önce ek servis çağrıları
   * gerekiyorsa) Promise<{text,data}> döndürebilir.
   */
  openDetailTabByKod(options: {
    entity: string;
    kod: number;
    pathPrefix: string;
    buildTabConfig: (data: any) => { text: string; data: any } | Promise<{ text: string; data: any }>;
    includedEntities?: string[];
    /** DKM-5225 Clara: tekil okuma isteğine eklenecek sorgu (ör. 'IkYetki=E'); verilmezse istek aynı. */
    query?: string;
  }): Promise<void> {
    if (options.kod == null) {
      return Promise.resolve();
    }

    const path = `${options.pathPrefix}${options.kod}`;
    const existing = this.pages.find((p) => p.path === path);
    if (existing) {
      this.setSelectedPage(existing);
      return Promise.resolve();
    }
    // 16.10.2026 ortak sekme kuralı: sınır doluysa kaydı sunucudan hiç çekme
    if (!this.detaySekmesiAcilabilir(path)) {
      return Promise.resolve();
    }

    return this.ortakServices
      // DKM-5225 Clara: eski hâli
      // .getEditFormDataWithKod(options.kod, options.entity, options.includedEntities)
      .getEditFormDataWithKod(options.kod, options.entity, options.includedEntities, options.query)
      .then(async (res) => {
        if (res?.length) {
          const tabConfig = await options.buildTabConfig(res[0]);
          this.addButtonHandler({
            path,
            text: tabConfig.text,
            data: tabConfig.data,
          });
        }
      });
  }

  /**
   * Ortak sekme kuralları (16.10.2026) — bütün kayıt detayı sekmeli ekranlar (GenKişi, IKA Personel, TemFiş, StsIhale, MbsTalep…):
   *  - aynı ana formdan en fazla DETAY_SEKME_SINIRI detay sekmesi ("Yeni"/"Kopya" sekmeleri dahil),
   *  - ana form kapatılırken ondan açılmış detaylar onayla birlikte kapanır (route-tab-lazy closeButtonHandlerTab).
   * Her açık sekme ekranını (DOM + DevExtreme bileşenleri) arka planda canlı tuttuğu için sınır belleği tavana bağlar.
   */
  static readonly DETAY_SEKME_SINIRI = 10;

  /**
   * Kayıt detayı sekmesinin ana formu, yoldan: '/GEN/GenKisiFormx12' ve '/TEM/TemFisFormx/new-…' → ana form yolu.
   * Detay değilse null. (Menü yüklenmesine bağlı değil; sekmeGorunum'un "ana"sı menüden geldiği için ondan ayrı.)
   */
  static detayAnaYolu(path: string | null | undefined): string | null {
    const m = /^(.+?Form)x(?=\d|\/)/.exec(path ?? '');
    return m ? m[1] : null;
  }

  /** Verilen ana formdan açılmış, şu an açık kayıt detayı sekmeleri. */
  acikDetaylar(anaYol: string | null | undefined): any[] {
    if (!anaYol) return [];
    return this.pages.filter((p) => DkNavService.detayAnaYolu(p?.path) === anaYol);
  }

  /**
   * Yeni bir sekme açılabilir mi: kayıt detayı değilse ya da zaten açıksa her zaman evet; detay sınırı doluysa
   * kullanıcıyı uyarır ve hayır döner.
   */
  detaySekmesiAcilabilir(path: string | null | undefined): boolean {
    const ana = DkNavService.detayAnaYolu(path);
    if (!ana || this.pages.some((p) => p.path === path)) return true;
    if (this.acikDetaylar(ana).length < DkNavService.DETAY_SEKME_SINIRI) return true;
    const ekran = this.sekmeBasligi(ana);
    alert(
      `${ekran ? '"' + ekran + '" ekranından' : 'Aynı ekrandan'} en fazla ${DkNavService.DETAY_SEKME_SINIRI} kayıt sekmesi açılabilir.<br>` +
      'Yeni bir kayıt açmak için açık olanlardan birini kapatın.',
      'Sekme sınırı'
    );
    return false;
  }

  /** Aktif sekmenin başlığını güncelle */
updateSelectedPageTitle(newTitle: string) {
  const index = this.selectedIndex;
  if (index < 0 || index >= this.pages.length) return;

  this.pages = this.pages.map((p, i) =>
    i === index ? { ...p, title: newTitle } : p
  );
  this._pages.next([...this.pages]);
}


  setSelectedPage(body: any) {
    const index = this.pages.findIndex((x) => x.path === body.path);
    if (index !== -1) {
      this.selectedIndex = index;
      this._selectedIndex.next(this.selectedIndex);
    } else {
      console.warn('setSelectedPage: Sayfa bulunamadı:', body);
    }
  }

  /** Açık sekmeler paneli sabit mi (pin modu); kapanan detaydan ana listeye dönüş için. */
  private calismaDuzeni = inject(CalismaDuzeniService);

  closeButtonHandler(itemData: any) {
    this._closedPageData.next(itemData)
    const index = this.pages.findIndex((p) => p.path === itemData?.path);
    if (index === -1) return;
    const seciliydi = index === this.selectedIndex;

    this.pages.splice(index, 1);
    if (index >= this.pages.length && index > 0) this.selectedIndex = index - 1;

    // 17.10.2026: pin modunda seçili kayıt detayı kapanınca (sekme ×, panel ×, formun kendi Kapat'ı) ana listesi
    // açıksa ona dönülür; değilse eskisi gibi komşu sekmeye.
    const ana = seciliydi && this.calismaDuzeni.panelSabit ? DkNavService.detayAnaYolu(itemData?.path) : null;
    const anaSira = ana ? this.pages.findIndex((p) => p.path === ana) : -1;
    if (anaSira >= 0) this.selectedIndex = anaSira;

    this._pages.next(this.pages);
    this._selectedIndex.next(this.selectedIndex);
  }

  showCloseButton() {
    return this.pages.length > 1;
  }

  disableButton() {
    return this.pages.length === this.allPages.length;
  }

  /** Yan menüde gösterilen modül (0 = Tüm Uygulamalar); modül penceresindeki "Açık" rozeti için. */
  aktifModulId = 0;

  getMenu(moduleId?: number): void {
    this.aktifModulId = moduleId ?? 0;
    this.ortakServices.getMenuTree(moduleId)
      .pipe(
        tap((res) => {
          const result = this.setRecursiveMenuData(res.menuList, moduleId);
          this._allPages.next(this.allPages);
          this._navigation.next(result);
        })
      )
      .subscribe();
  }

  getSikKullanilan(e: any) {
    if (e) {
      const body = {
        path: e?.url,
        title: e?.menuTitle,
        data: ""
      };
      const index = this.pages.findIndex((x) => x.path === body.path);
      if (index === -1) {
        this.pages.push(body);
        this._pages.next(this.pages);
        this.selectedIndex = this.pages.length - 1;
        this._selectedIndex.next(this.selectedIndex);
      } else {
        this.selectedIndex = index;
        this._selectedIndex.next(this.selectedIndex);
      }
    }
  }

  getModules(moduleId: number = -1, app: string = "App") {
    this.ortakServices.getMenuTree(moduleId, app)
      .pipe(
        tap((navigation) => {
          const result = this.setRecursiveModulesData(navigation.menuList);
          this._allPages.next(this.allPages);
          this._navigationx.next(result);
        })
      )
      .subscribe();
  }

  /**
   * getModules(0, app) ile gelen ağaç sığdır (backend ilk seviyelerden sonrasını
   * göndermeyebiliyor). Masaüstündeki getMenu(moduleId) ile aynı mantık: bir
   * modülün TAM alt ağacı, o modülün kendi moduleId'siyle tek seferde istenir
   * (dönen liste modülün doğrudan çocuklarıdır, iç içe subMenus ile birlikte).
   */
  getModuleTree(moduleId: number, app: string = 'Mobile'): Observable<MenuDto[]> {
    return this.ortakServices.getMenuTree(moduleId, app).pipe(
      map((res) => this.setRecursiveModulesData(res.menuList))
    );
  }

  getFav(isFirst: boolean) {
    this.ortakServices.getMenuTree(-2)
      .pipe(
        tap((res) => {
          if (isFirst) this.getSikKullanilan(res?.menuList[0])
          const result = this.setRecursiveMenuData(res?.menuList, -2);
          this._favNavigation.next(result);
        })
      )
      .subscribe();
  }

  setRecursiveModulesData(arr: MenuDto[]): MenuDto[] {
    // Servis response objesini acınca any duzeltilmeli
    const returnArr: MenuDto[] = [];
    arr.forEach((element) => {
      if (element.subMenus) {

        const menuDto = new MenuDto({
          menuId: element.menuId,
          parentId: element.parentId,
          menuType: element.menuType,
          formId: element.formId,
          url: element.url,
          menuTitle: element.menuTitle,
          icon: element.icon,
          moduleId: element.moduleId,
          items: this.setRecursiveModulesData(element.subMenus),
        });
        returnArr.push(menuDto)
      } else {
        const menuDto = new MenuDto({
          menuId: element.menuId,
          parentId: element.parentId,
          menuType: element.menuType,
          formId: element.formId,
          url: element.url,
          menuTitle: element.menuTitle,
          icon: element.icon,
          moduleId: element.moduleId,
        });
        returnArr.push(menuDto)
        this.allPages.push({
          url: element.url,
          menuTitle: element.menuTitle,
        });
      }
    });
    return returnArr;
  }

  setRecursiveMenuData(arr: MenuDto[], moduleId: number, ustRenk?: string): DevMenuModel[] {
    // Servis response objesini acınca any duzeltilmeli
    let expandedMenu = true;
    if (moduleId === 0) expandedMenu = false;
    const returnArr: DevMenuModel[] = [];
    arr.forEach((element) => {
      // MENU_ICON_URL 'fa-solid fa-coins #059669' → ikon + renk; renk kökten alt düğümlere geçer.
      // Favoriler (-2) düz liste, modül bilgisi yok → renksiz kalır.
      const gorunum = menuIkonCoz(element.icon);
      const renk = gorunum.renk ?? ustRenk ??
        (moduleId !== -2 && element.parentId == 0 ? yedekRenk(element.moduleId) : undefined);
      // Formlar da boş subMenus ([]) ile geldiği için iki dalda da geçerli: sayfa yolu → modül rengi
      if (element.url && renk) this.sekmeRenkleri.set(element.url, renk);
      // Açık sekmeler listesi (10.10.2026): sayfa yolu → menüdeki form ikonu
      if (element.url) {
        this.sekmeIkonlari.set(element.url, turIkonu(gorunum.ikon || varsayilanIkon(element.menuType), element.formName));
        if (element.menuTitle) this.sekmeBasliklari.set(element.url, element.menuTitle);
        this.sekmeGorunumleri.clear();
      }
      if (element.subMenus) {
        returnArr.push({
          path: element.url,
          text: element.menuTitle,
          icon: turIkonu(gorunum.ikon || varsayilanIkon(element.menuType), element.formName),
          formId: element.formId,
          expanded: expandedMenu,
          menuType: element.menuType.toString(),
          renk,
          items: this.setRecursiveMenuData(element.subMenus, moduleId, renk),
        });
      } else {
        returnArr.push({
          path: element.url,
          text: element.menuTitle,
          icon: turIkonu(gorunum.ikon || varsayilanIkon(element.menuType), element.formName),
          formId: element.formId,
          expanded: expandedMenu,
          menuType: element.menuType.toString(),
          renk,
        });

        this.allPages.push({
          path: element.url,
          text: element.menuTitle,
          formId: element.formId,
          expanded: expandedMenu,
          menuType: element.menuType.toString(),
        });
      }
    })
    return returnArr;
  }

  /**
   * Sekme şeridindeki modül noktası için: sayfa yolu → menüdeki modül rengi.
   * allPages resetState/getModules ile değiştiği için ayrı tutulur; menü her yüklendiğinde birikir.
   */
  private sekmeRenkleri = new Map<string, string>();

  // eski hâli (10.10.2026; kayıt detayı sekmeleri menüde olmadığı için noktasızdı):
  // sekmeRengi(path: string | null | undefined): string | undefined {
  //   return path ? this.sekmeRenkleri.get(path) : undefined;
  // }
  sekmeRengi(path: string | null | undefined): string | undefined {
    return path ? (this.sekmeRenkleri.get(path) ?? this.sekmeGorunum(path).renk) : undefined;
  }

  /** Açık sekmeler listesi: sayfa yolu → menüdeki form ikonu (sekmeRenkleri gibi menü yüklendikçe birikir). */
  private sekmeIkonlari = new Map<string, string>();
  /** Açık sekmeler paneli (15.10.2026): sayfa yolu → menü başlığı; kayıt gruplarının başlığı (sekmeIkonlari gibi birikir). */
  private sekmeBasliklari = new Map<string, string>();

  sekmeBasligi(path: string | null | undefined): string | undefined {
    return path ? this.sekmeBasliklari.get(path) : undefined;
  }

  /** sekmeGorunum sonuçları; şablon her çizimde çağırdığı için önbellekli, menü değişince boşalır. */
  private sekmeGorunumleri = new Map<string, SekmeGorunum>();

  /**
   * Açık sekmeler listesinde sekmenin ikonu, modül rengi ve türü.
   *  - Menüdeki form: menü ikonu (varsayılan form ikonu → liste ikonu; rapor/dashboard kendi ikonunu korur).
   *  - Menüde olmayan ama bir menü formunun yolundan türeyen sekme (örn. /GEN/GenKisiFormx12): kayıt detayı;
   *    rengi ana formdan alır.
   */
  sekmeGorunum(path: string | null | undefined, data?: unknown): SekmeGorunum {
    const yol = path ?? '';
    const onbellek = this.sekmeGorunumleri.get(yol);
    if (onbellek) return onbellek;

    let sonuc: SekmeGorunum;
    let kesin = true; // menüden kesin bilinen sonuç; veriye göre tahminler önbelleğe yazılmaz
    const bilinen = DkNavService.BILINEN_SEKME_IKONLARI[yol];
    const menuIkonu = this.sekmeIkonlari.get(yol);
    if (bilinen) {
      sonuc = { ikon: bilinen, renk: this.sekmeRenkleri.get(yol), detay: false };
    } else if (menuIkonu) {
      sonuc = { ikon: menuIkonu === 'fa-regular fa-file-lines' ? 'fa-solid fa-table-list' : menuIkonu, renk: this.sekmeRenkleri.get(yol), detay: false };
    } else {
      // en uzun eşleşen menü yolu = kaydın ana formu
      let ana = '';
      for (const url of this.sekmeIkonlari.keys()) {
        if (url.length > ana.length && url.length > 4 && yol.startsWith(url)) ana = url;
      }
      const veriVar = !!data && typeof data === 'object' && Object.keys(data as object).length > 0;
      kesin = !!ana;
      sonuc = ana || veriVar
        ? { ikon: 'fa-solid fa-file-pen', renk: ana ? this.sekmeRenkleri.get(ana) : undefined, detay: true, ana: ana || undefined }
        : { ikon: 'fa-regular fa-window-maximize', renk: undefined, detay: false };
    }
    if (yol && kesin) this.sekmeGorunumleri.set(yol, sonuc);
    return sonuc;
  }

  /** Sunucuda menü kaydı olmayan kod tarafı sekmelerin ikonları. */
  private static readonly BILINEN_SEKME_IKONLARI: Record<string, string> = {
    [DkNavService.GOREVLERIM_YOLU]: 'fa-solid fa-list-check',
    [DkNavService.TAKVIM_YOLU]: 'fa-regular fa-calendar',
    [DkNavService.ANALIZ_MERKEZI_YOLU]: 'fa-solid fa-chart-column',
  };

  getFormName(page: any): string {
    return page.slice(page.lastIndexOf("/") + 1)
  }
  resetState() {
    // 🔹 Tüm BehaviorSubject ve dizileri sıfırla
    this.pages = [];
    this.allPages = [];
    this.selectedIndex = 0;

    // 🔹 Subject'leri notify et
    this._pages.next([]);
    this._allPages.next([]);
    this._selectedIndex.next(0);

    // 🔹 Kapalı sayfa bilgisi sıfırla
    this._closedPageData.next(null);

  }


}
